import { type FC, useState } from 'react';
import { graphql, useFragment } from 'react-relay';
import classnames from 'classnames';

import { VisibilityTracker } from 'dibs-visibility-tracker/exports/VisibilityTracker.tsx';
import { HeroBannerItem } from './HeroBannerItem.tsx';
import { Carousel } from '../Carousel/index.tsx';

import { type HeroBannerCarousel_cmsNftExhibitionPage$key } from './__generated__/HeroBannerCarousel_cmsNftExhibitionPage.graphql.ts';

import styles from './styles/HeroBannerCarousel.scss';

type Props = {
    cmsNftExhibitionPage: HeroBannerCarousel_cmsNftExhibitionPage$key | null | undefined;
};

export const HeroBannerCarousel: FC<Props> = ({
    cmsNftExhibitionPage: cmsNftExhibitionPageRef,
}) => {
    const cmsNftExhibitionPage = useFragment(
        graphql`
            fragment HeroBannerCarousel_cmsNftExhibitionPage on NftCmsExhibitionPage {
                heroBanner {
                    format
                    ...HeroBannerItem_heroBannerItemExhibition
                }
            }
        `,
        cmsNftExhibitionPageRef
    );
    const items = cmsNftExhibitionPage?.heroBanner || [];
    const [isCarouselVisible, setIsCarouselVisible] = useState<boolean>(false);
    return (
        <>
            <VisibilityTracker
                watchAfterFirstVisible
                onVisibilityChange={({ isVisible }) => {
                    if (isVisible !== isCarouselVisible) {
                        setIsCarouselVisible(isVisible);
                    }
                }}
            />
            <Carousel
                showDots={items.length > 1}
                hideArrows
                isFullWidth
                itemsPerPage={1}
                classNames={{
                    wrapper: classnames(
                        styles.carouselWrapper,
                        styles.important,
                        styles.moduleContainer
                    ),
                }}
                count={items.length}
                renderItem={({ index, isVisible }: { isVisible?: boolean; index: number }) =>
                    items?.[index] ? (
                        <HeroBannerItem
                            index={index}
                            inViewport={isCarouselVisible}
                            isVisible={isVisible}
                            heroBannerItemExhibition={cmsNftExhibitionPageRef ? items[index] : null}
                        />
                    ) : null
                }
            />
        </>
    );
};
